module.exports = __webpack_public_path__ + "img/PAG313_1-1.a370d8c8.jpg";